/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_InputInputs */

const es_chat_tool_detail_input = /** @type {(inputs: Chat_Tool_Detail_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parámetros`)
};

const en_chat_tool_detail_input = /** @type {(inputs: Chat_Tool_Detail_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parameters`)
};

/**
* | output |
* | --- |
* | "Parameters" |
*
* @param {Chat_Tool_Detail_InputInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_input = /** @type {((inputs?: Chat_Tool_Detail_InputInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_InputInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_input(inputs)
	return en_chat_tool_detail_input(inputs)
});
export { chat_tool_detail_input as "chat.tool_detail.input" }